
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spin-to-win",
      function () {
        return require("private-next-pages/spin-to-win/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spin-to-win"])
      });
    }
  